module.exports = __webpack_public_path__ + "media/assets/images/logo_votorantim-342f8063a69576811a20cd6f3f1a8066.png";